import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { TGridCSSVariables } from '../../../../constants/table.constants';
import { FixedColumnRefType, TMainTable } from '../../types/index.types';
import ColumnHeadingElement from './columnHeading/columnHeadings';
import FixedColHeading from './columnHeading/fixedColHeading';
import RowItems from './row';
import MSRPRow from './row/msrpRow';

const MainTable = (props: TMainTable, ref) => {
  const GridRef = useRef(null);
  const TableWrapperRef = useRef<HTMLDivElement | null>(null);
  const fixedColumnRef = useRef<FixedColumnRefType>(null);

  useImperativeHandle(ref, () => ({
    get GridRef() {
      return GridRef;
    },
    get TableWrapperRef() {
      return TableWrapperRef;
    },
  }));

  const {
    backgroundColorClass,
    fixedColumnHeading,
    searchTerm,
    mrpRow,
    categoryRows,
    gridColumns,
    gridFixedColHeadsMoveBy,
    gridColumnWidth,
    gridOutsideSpaceHalved,
    gridLeftCellsMoveBy,
    colHeadings,
    setDropdownAtColumnIndex,
    setColOrdInIndex,
    dropdownAtColumnIndex,
    colOrdInIndex,
    backgroundColor,
    toggleRow,
    title,
    eyebrow,
    expandedRows,
    showHiddenRightCells,
    setShowHiddenRightCells,
  } = props;

  useEffect(() => {
    if (GridRef.current && fixedColumnHeading) {
      const tableWrapperEl = TableWrapperRef.current as HTMLElement;
      const tableEl = tableWrapperEl.getElementsByTagName('table')?.[0];
      const fixedColHeadingEl = fixedColumnRef?.current?.FixedColHeadingRef?.current as HTMLDivElement | null;
      if (!tableEl || !fixedColHeadingEl) return;

      const leftValue = tableEl.getBoundingClientRect().left;
      if (!leftValue) return;

      fixedColHeadingEl.style.setProperty(TGridCSSVariables.gridFixedColHeadsMoveBy, `${leftValue || 0}px`);
    }
  }, [fixedColumnHeading, TableWrapperRef]);

  const handleScroll = (event) => {
    const leftValue = event.target.scrollLeft;

    const fixedColHeadingEl = fixedColumnRef?.current?.FixedColHeadingRef?.current as HTMLDivElement | null;
    if (fixedColHeadingEl && leftValue >= 0) {
      fixedColHeadingEl.style.setProperty(TGridCSSVariables.gridFixedColHeadsMoveBy, `-${leftValue}px`);
    }
    if (!showHiddenRightCells) setShowHiddenRightCells(true);
  };
  return (
    <div
      className={`model-detail-specification-table model-detail-specification-table--${backgroundColorClass}-background`}
      ref={TableWrapperRef}
      onScroll={handleScroll}
    >
      <table className="model-detail-specification-table__table-tag" cellPadding="0" cellSpacing="0" ref={GridRef}>
        <FixedColHeading
          ref={fixedColumnRef}
          showFixedColumnHeading={
            !!(fixedColumnHeading && (searchTerm ? !!mrpRow.hideRow || (categoryRows && categoryRows.length > 0) : true))
          }
          gridColumns={gridColumns}
          gridFixedColHeadsMoveBy={gridFixedColHeadsMoveBy}
          gridColumnWidth={gridColumnWidth}
          gridOutsideSpaceHalved={gridOutsideSpaceHalved}
          gridLeftCellsMoveBy={gridLeftCellsMoveBy}
          backgroundColorClass={backgroundColorClass}
        >
          <ColumnHeadingElement
            colHeadings={colHeadings}
            setDropdownAtColumnIndex={setDropdownAtColumnIndex}
            setColOrdInIndex={setColOrdInIndex}
            dropdownAtColumnIndex={dropdownAtColumnIndex}
            colOrdInIndex={colOrdInIndex}
            fixedColumn={true}
            showHiddenRightCells={showHiddenRightCells}
          />
        </FixedColHeading>
        <tbody>
          <tr>
            <th className="model-detail-specification-table__left-most-cell">
              <div className="model-detail-specification-table__left-most-empty-cell" />
            </th>
            {(searchTerm ? !mrpRow.hideRow || (categoryRows && categoryRows.length > 0) : true) && (
              <ColumnHeadingElement
                colHeadings={colHeadings}
                setDropdownAtColumnIndex={setDropdownAtColumnIndex}
                setColOrdInIndex={setColOrdInIndex}
                dropdownAtColumnIndex={dropdownAtColumnIndex}
                colOrdInIndex={colOrdInIndex}
                fixedColumn={false}
                showHiddenRightCells={showHiddenRightCells}
              />
            )}
          </tr>
          <MSRPRow mrpRow={mrpRow} searchTerm={searchTerm} colOrdInIndex={colOrdInIndex} showHiddenRightCells={showHiddenRightCells} />
          {categoryRows?.map((obj, index) => (
            <RowItems
              key={obj.group}
              obj={obj}
              backgroundColor={backgroundColor}
              toggleRow={toggleRow}
              index={index}
              title={title}
              eyebrow={eyebrow}
              searchTerm={searchTerm}
              colHeadings={colHeadings}
              expandedRows={expandedRows}
              colOrdInIndex={colOrdInIndex}
              showHiddenRightCells={showHiddenRightCells}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(forwardRef(MainTable));
